module.exports = __webpack_public_path__ + "img/vertical_4_1_3009.8e6d0ba2.png";